// The page asked for before an Auth0 login, held for the callback page to send the user back to.
let pending: string | null = null

// The router matches paths without regard to case or a trailing slash, so the callback must be recognised the same way.
export const isCallbackPath = (pathname: string): boolean => pathname.replace(/\/+$/, '').toLowerCase() === '/callback'

/** A path on this site to return to, or null for anything that could leave it or land back on the login callback. */
export function safeReturnTo(value: unknown): string | null {
  if (typeof value !== 'string' || !value.startsWith('/') || /[\s\\]/.test(value)) return null
  const url = new URL(value, window.location.origin)
  if (url.origin !== window.location.origin || isCallbackPath(url.pathname)) return null
  return `${url.pathname}${url.search}${url.hash}`
}

export function rememberReturnTo(value: unknown): void {
  pending = safeReturnTo(value)
}

// Read without clearing: dev mode runs the callback's effect twice, and a second read must agree with the first.
export function returnToAfterLogin(): string | null {
  return pending
}
